import { defineMessages } from 'react-intl-next';
export default defineMessages({
  footerText: {
    id: 'fabric.editor.ai.screens.UserInputCommamdPalette.footerText',
    defaultMessage: 'Atlassian Intelligence',
    description: 'Atlassian Intelligence footer text for user input command palette screen'
  },
  commandPaletteAriaName: {
    id: 'fabric.editor.ai.experience.commandPaletteAriaName',
    defaultMessage: 'Atlassian Intelligence',
    description: 'Accessible label for the user input dialog'
  }
});